<template>
  <div>
    <el-container direction="vertical">
      <el-row>
        <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%">
          <el-table-column width="100px" align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.patientName }}</span>
            </template>
          </el-table-column>
          <el-table-column width="115px" align="center" label="联系方式">
            <template slot-scope="scope">
              <span>{{ scope.row.phone || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150px" align="center" label="随访时间">
            <template slot-scope="scope">
              <span>{{ getParsedTime(scope.row.displayFollowupTime) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="状态">
            <template slot-scope="scope">
              <span>{{ scope.row.displayStatus }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="随访类型">
            <template slot-scope="scope">
              <span>{{ scope.row.displayFollowupType }}</span>
            </template>
          </el-table-column>

          <el-table-column min-width="248px" align="center" label="项目">
            <template slot-scope="scope">
              <span>{{ scope.row.displayReviewItem }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150px" align="center" label="复查到期时间">
            <template slot-scope="scope">
              <span>{{ getParsedTime(scope.row.displayReviewExpireTime) }}</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="handleView(scope.$index, scope.row)">查看随访详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="formData.pageNum" :limit.sync="formData.pageSize"
          @pagination="turnToPage" />

        <followupModal v-if="followupModalVisible" ref="followupModalRef" />
      </el-row>
    </el-container>
  </div>
</template>

<script>
import {
  getListByTime,
} from "@/api/health/Patients.js"
import Pagination from "@/components/Pagination";
import followupModal from "@/components/followupModal/index.vue";
import { normalizeLungFollowupRecord } from "@/utils/lung-followup-record";
import imageLine from "@/assets/images/titleLine.png";
import moment from "moment";

export default {
  components: { Pagination, followupModal },
  props: {
    pInfo: null
  },
  data() {
    return {
      open: false,
      followupModalVisible: false,
      linkLine: imageLine,
      form: {
        patientName: null,
        status: null,
        idcard: null,
        type: null,
        serviceName: '肺结节随访',
        orderByReviewExpireTime: true,
        // followupFlag: "1",
      },
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      listLoading: false,
      total: 0,
      list: []
    };
  },
  watch: {},
  created() {
    this.getList(this.pInfo);
  },
  methods: {
    setOpen(bool) {
      this.open = bool;
    },
    getList(row = {}) {
      this.list = [];
      this.listLoading = true;

      getListByTime({ ...this.form, idcard: row.idcard }).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.total = res.data.total;
          this.list = (res.data.records || []).map(normalizeLungFollowupRecord);
        }
      }).catch(error => {
        console.log(error);
        this.listLoading = false;
      });
    },
    // 导航跳转查询列表页
    turnToPage() {
      const params = Object.assign({}, this.form, this.formData)
      this.listLoading = true;
      getListByTime({ ...params, idcard: this.pInfo?.idcard }).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.list = (res.data.records || []).map(normalizeLungFollowupRecord);
          this.total = res.data.total;
        }
      });
    },
    handleView(index, row) {
      this.followupModalVisible = true;
      this.$nextTick(() => {
        this.$refs.followupModalRef.init({ ...row, pInfo: this.pInfo, isRead: true });
      });
    },
    getParsedTime(time) {
      if (!time) return "-";
      return moment(time).format("YYYY-MM-DD");
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-table thead th {
  background-color: #f5f5f5 !important;
}
</style>
1
